import * as types from './mutation-types'

export default {
  [types.ADD_NORMALIZATION](state, data) {
    state.normalization = data
  },
}
